import { jsx as r } from "react/jsx-runtime";
import { Popover as m } from "@datamole/wds-component-popover";
import { ComboboxContext as d } from "../contexts/combobox.context.js";
const b = (n) => {
  const {
    value: a,
    hasError: l = !1,
    disabled: p = !1,
    isMenuOpen: o,
    placeholder: s,
    children: t,
    onClear: i,
    setIsMenuOpen: e
  } = n;
  return /* @__PURE__ */ r(
    d.Provider,
    {
      value: {
        value: a,
        hasError: l,
        disabled: p,
        isMenuOpen: o,
        placeholder: s,
        onClear: i,
        setIsMenuOpen: e
      },
      children: /* @__PURE__ */ r(m, { open: o, onOpenChange: e, children: t })
    }
  );
};
b.displayName = "Combobox";
export {
  b as Root
};
